import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=37a5f9b8&scoped=true&lang=pug"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignIn.vue?vue&type=style&index=0&id=37a5f9b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f9b8",
  null
  
)

export default component.exports